import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';

import constants from 'constants/constants';

import changeScreen from 'actions/router';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper
} from 'containers';

import { Text, Icon } from 'components';
import { DisplayButton, LeftRightButton } from 'components/buttons';

import styles from './MainEngineStarted.scss';

class MainEngineStarted extends Component {
  constructor(props) {
    super(props);

    const { initialRpmValue } = this.props;

    this.state = {
      buttonConfig: {
        left: {
          onClick: this.handleLeftClick
        },
        center: {
          onClick: this.handleCenterClick
        },
        right: {
          onClick: this.handleRightClick
        }
      },
      rpm: initialRpmValue
    };
  }

  handleLeftClick = () => {
    this.changeMenuOption('min');
  }

  handleCenterClick = () => {
    this.changeMenuOption('eco');
  }

  handleRightClick = () => {
    this.changeMenuOption('max');
  }

  changeMenuOption = (option) => {
    const { options } = this.props;
    const rpm = options[option].value;

    this.setState({ rpm });
  }

  handleBothClick = () => {
    const { navigateTo } = this.props;
    const { rootRoute } = constants;

    navigateTo(`${rootRoute}/default`);
  }

  render() {
    const { rpm, buttonConfig } = this.state;
    const {
      iconLeft,
      iconRight,
      engineType,
      options
    } = this.props;

    const buttons = Object.keys(options).map(key => (
      <DisplayButton
        key={uuidv4()}
        src={`icon-xm-${options[key].icon}`}
        selected={rpm === options[key].value}
      />
    ));

    return [
      <Display key={uuidv4()}>
        <Header buttonContainer noMargin>
          <DisplayButton src="icon-xm-settings-full" selected />
          <DisplayButton src="icon-xm-p" selected />
          <DisplayButton src="icon-xm-n" selected />
          <DisplayButton src="icon-xm-person" selected />
        </Header>
        <Content>
          <div className={styles.content}>
            <Icon
              src={iconLeft}
              noBorder
              engineType={engineType}
            />
            <div>
              <Text value={rpm} center />
              <Text value="RPM" center />
            </div>
            <Icon
              src={iconRight}
              noBorder
              engineType={engineType}
            />
          </div>
        </Content>
        <Footer>
          {buttons}
        </Footer>
      </Display>,
      <LeftRightButton
        key={uuidv4()}
        onClick={this.handleBothClick}
      />,
      <HardwareButtonWrapper key={uuidv4()} config={buttonConfig} />
    ];
  }
}

MainEngineStarted.defaultProps = {
  engineType: '',
  options: {
    min: {
      icon: '',
      value: ''
    },
    eco: {
      icon: '',
      value: ''
    },
    max: {
      icon: '',
      value: ''
    }
  }
};

MainEngineStarted.propTypes = {
  iconLeft: PropTypes.string.isRequired,
  iconRight: PropTypes.string.isRequired,
  engineType: PropTypes.string,
  navigateTo: PropTypes.func.isRequired,
  initialRpmValue: PropTypes.string.isRequired,
  options: PropTypes.shape({
    min: PropTypes.shape({
      icon: PropTypes.string,
      value: PropTypes.string
    }),
    eco: PropTypes.shape({
      icon: PropTypes.string,
      value: PropTypes.string
    }),
    max: PropTypes.shape({
      icon: PropTypes.string,
      value: PropTypes.string
    })
  })
};

export default connect(({ workflow }) => ({
  options: workflow.data.options
}), {
  navigateTo: changeScreen
})(MainEngineStarted);



// WEBPACK FOOTER //
// ./src/screens/shared/MainEngineStarted/MainEngineStarted.js